export const myMixins = {
    components:{},
    data() {
      return {
        // age: 18,
        imgurl:'http://xwzx.hohu.com.cn',
        // currentScroll: 0,
      }
    },
    created(){
    },
    mounted() {
        // window.addEventListener('scroll', this.handleScrollbox, true)
        //   this.getAge()
    },
    methods: {
        initmeta(i){
          let meta = new Object
          meta.title = this.tagNav[i].seo_title
          meta.keywords = this.tagNav[i].seo_keywords
          meta.description = this.tagNav[i].seo_desc
          this.$store.commit('setmeta', meta)
        },
        meta(obj){
          this.$store.commit('setmeta', obj)
        },
        _isMobile() {
          let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
          return flag;
        },
    },
    
    // beforeDestroy() {
    //     window.removeEventListener('scroll', this.handleScrollbox, true)
    // },
}
  